import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { selectClass } from './styles';
import { isObject } from '../utils/is';
import shallowEqual from '../utils/shallowEqual';
import icons from '../icons';
import { getDirectionClass } from '../utils/classname';

var Option =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Option, _React$Component);

  var _super = _createSuper2(Option);

  function Option(props) {
    var _this;

    _classCallCheck(this, Option);

    _this = _super.call(this, props);
    _this.locked = void 0;
    _this.handleEnter = void 0;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleEnter = _this.handleHover.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Option, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.filterText) return true;
      if (!shallowEqual(nextProps, this.props) || !shallowEqual(nextState, this.state)) return true;
      return false;
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          onClick = _this$props.onClick,
          isActive = _this$props.isActive,
          disabled = _this$props.disabled,
          groupKey = _this$props.groupKey;
      if (this.locked || disabled || data && data[groupKey]) return;
      this.locked = true;
      onClick(!isActive, data);
      setTimeout(function () {
        _this2.locked = false;
      }, 200);
    }
  }, {
    key: "handleHover",
    value: function handleHover() {
      this.props.onHover(this.props.index);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          isActive = _this$props2.isActive,
          index = _this$props2.index,
          renderItem = _this$props2.renderItem,
          isHover = _this$props2.isHover,
          disabled = _this$props2.disabled,
          groupKey = _this$props2.groupKey;
      var isGroupTitle = data && data[groupKey];
      var className = classnames(selectClass(getDirectionClass('option'), isActive && 'active', isHover && 'hover', disabled && getDirectionClass('disabled'), isGroupTitle && 'group'), "option-".concat(index));
      var result = isGroupTitle ? data[groupKey] : renderItem(data, index);
      var title = typeof result === 'string' ? result : '';

      if (isObject(data) && result === data) {
        console.warn('renderItem is essential when data element is Object');
      }

      return (
        /*#__PURE__*/
        React.createElement("a", {
          tabIndex: -1,
          onClick: this.handleClick,
          onMouseEnter: this.handleEnter,
          className: className,
          title: title
        }, result, isActive && icons.Check)
      );
    }
  }]);

  return Option;
}(React.Component);

export default Option;